var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestrictionAlerteRenforcee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.2 30.2",
    style: {
      enableBackground: "new 0 0 30.2 30.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M12.4,8c-0.2-0.5-0.6-0.8-1.1-0.8c-0.4,0-0.9,0.3-1.1,0.8L5.2,20.4l0,0c-0.1,0.2-0.1,0.4-0.1,0.5 c0,0.8,0.6,1.2,1.2,1.2c0.5,0,0.9-0.3,1.1-0.8c0.3-0.8,0.6-1.6,0.9-2.4h5.8l1,2.4c0.2,0.4,0.7,0.8,1.1,0.8c0.6,0,1.2-0.4,1.2-1.2 c0-0.1,0-0.2-0.1-0.4L12.4,8z M9.3,16.6l2-4.9l2,4.9H9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M23.9,12.3c-0.4-0.1-0.7-0.1-1.1-0.1c-0.6,0-1.4,0.2-2,0.7c-0.2-0.4-0.6-0.7-1.1-0.7c-0.7,0-1.1,0.4-1.1,1.2 v7.6c0,0.7,0.4,1.1,1.1,1.1c0.6,0,1.1-0.4,1.1-1.1v-5.3c0.4-0.6,0.9-1.3,1.7-1.3c0.3,0,0.5,0,0.7,0.1h0c0.6,0.2,1.3-0.1,1.5-0.8 C24.9,13.1,24.5,12.5,23.9,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M26.3,0.1H3.9c-2,0-3.7,1.6-3.7,3.7v22.4c0,2,1.6,3.7,3.7,3.7h22.4c2,0,3.7-1.6,3.7-3.7V3.8 C30,1.8,28.3,0.1,26.3,0.1z M27.6,26.2c0,0.7-0.6,1.3-1.3,1.3H3.9c-0.7,0-1.3-0.6-1.3-1.3V3.8c0-0.7,0.6-1.3,1.3-1.3h22.4 c0.7,0,1.3,0.6,1.3,1.3V26.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictionAlerteRenforcee);
export default __webpack_public_path__ + "static/media/Restriction_AlerteRenforcee.c91307ff.svg";
export { ForwardRef as ReactComponent };